/* ============================================================
   Modulo Logo Cloud — seamless infinite scroll.

   Strategy:
   - Measure one "cycle" = width of N original items + N gaps
     (N items + 1 trailing gap between cycles).
   - Clone enough copies that total track ≥ viewport + 1 cycle,
     so there's always off-screen content queued on both sides.
   - Set --modulo-lc-cycle-width so CSS animates by exact pixels,
     landing on a clean cycle boundary every loop — no visible snap.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function getGap(el) {
    var style = getComputedStyle(el);
    var raw = style.columnGap || style.gap || '0';
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function measureCycle(originals, gap) {
    var w = 0;
    for (var i = 0; i < originals.length; i++) {
      w += originals[i].getBoundingClientRect().width;
    }
    // One gap per item so the cycle includes its trailing gap,
    // which keeps the loop boundary aligned between repeats.
    return w + gap * originals.length;
  }

  function cloneSet(track, originals) {
    for (var i = 0; i < originals.length; i++) {
      var clone = originals[i].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      track.appendChild(clone);
    }
  }

  function initLogocloud(el) {
    var track = el.querySelector('.modulo-lc__track');
    if (!track || track.dataset.moduloLcReady === '1') return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length === 0) return;

    var gap = getGap(track);
    var cycleWidth = measureCycle(originals, gap);

    // If items failed to layout (e.g. images not loaded), bail.
    if (cycleWidth <= 0) return;

    var viewportWidth = el.offsetWidth || document.documentElement.clientWidth;
    // Need track wide enough that at any translation during the animation
    // the viewport is always fully covered: viewport + 1 cycle buffer.
    var required = viewportWidth + cycleWidth;
    var copiesNeeded = Math.max(2, Math.ceil(required / cycleWidth));

    for (var c = 0; c < copiesNeeded; c++) {
      cloneSet(track, originals);
    }

    track.style.setProperty('--modulo-lc-cycle-width', cycleWidth + 'px');
    track.dataset.moduloLcReady = '1';
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-logocloud]', initLogocloud);
    } else {
      var els = document.querySelectorAll('[data-modulo-logocloud]');
      for (var i = 0; i < els.length; i++) initLogocloud(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-measure on viewport resize so wider screens stay filled.
  // We only ADD clones here (never remove) — cheap and safe.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var els = document.querySelectorAll('[data-modulo-logocloud]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var track = el.querySelector('.modulo-lc__track');
        if (!track || track.dataset.moduloLcReady !== '1') continue;
        var needed = el.offsetWidth * 2;
        var safety = 0;
        while (track.scrollWidth < needed && safety < 4) {
          var snapshot = Array.prototype.slice.call(track.children);
          for (var j = 0; j < snapshot.length; j++) {
            var clone = snapshot[j].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('role');
            track.appendChild(clone);
          }
          safety++;
        }
      }
    }, 200);
  });
})();
